import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginResponse } from '../api';

export interface AuthState {
  isAuthenticated: boolean;
  email: string | null;
  role: LoginResponse['role'] | null;
  group: LoginResponse['group'] | null;
  userId: LoginResponse['userId'] | null;
  adminGroup: LoginResponse['adminGroup'] | null;
}

const initialState: AuthState = {
  email: null,
  role: null,
  group: null,
  userId: null,
  adminGroup: null,
  // we can't directly check if there is auth token (http-only cookie), so we use local storage to not wait for http response
  // not the best solution
  isAuthenticated: !!localStorage.getItem('isLogin')
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<LoginResponse>) {
      const { userId, role, group, adminGroup, email } = action.payload;
      localStorage.setItem('isLogin', 'true');
      return {
        ...state,
        email,
        userId,
        role,
        group,
        runTask: group.runTask,
        adminGroup: adminGroup,
        isAuthenticated: true
      };
    },
    clearUser(state) {
      localStorage.removeItem('isLogin');
      return {
        ...state,
        email: null,
        userId: null,
        role: null,
        group: null,
        adminGroup: null,
        isAuthenticated: false
      };
    }
  }
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
